module.exports = __webpack_public_path__ + "static/media/data.a2efc5eb.csv";